import { Component, OnInit } from '@angular/core';
import { CategoriasService } from '../../../services/categorias.service';

import { Categoria } from '../../../models/categoria';

import { map } from 'rxjs/operators';

import Swal from 'sweetalert2'

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: ['./categoria.component.css']
})
export class CategoriaComponent implements OnInit {

  ds_categorias;

  constructor(
    private _categorias: CategoriasService
  ) { }

  ngOnInit(): void {
    this.consultar();
  }

  consultar(){
    this._categorias.getAll().snapshotChanges().pipe(
      map( changes =>
        changes.map( d =>
          ({ uid: d.payload.doc.id, ...d.payload.doc.data() })
        )
      )
    ).subscribe( categorias => {
      this.ds_categorias = categorias;
    })
  }

  nuevo(){
    Swal.fire({
      title: 'Escribe el nombre de la nueva categoría',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'on'
      },
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {

        try {
          let obj = { 'categoria' : <string>result.value, orden: this.ds_categorias.length };
          this.ds_categorias.push(obj);
          let r = this._categorias.nuevo(obj);
          console.log({r})
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Categoría Creada',
            showConfirmButton: false,
            timer: 1500
          })
        } catch (error) {
          console.log({error})
        }

      }
    })
  }

  editar(index:any, obj:any){

    Swal.fire({
      title: 'Escribe el nuevo nombre para la categoría',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'on'
      },
      showCancelButton: true,
      confirmButtonText: 'Cambiar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {

        
        try {
          this.ds_categorias[index].categoria = <string>result.value;

          this._categorias.edit(obj, obj.uid);
  
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Categoría Modificada',
            showConfirmButton: false,
            timer: 1500
          })        
          
        } catch (error) {
          console.log({error})
        }
      }
    })

  }

  editarPosicion(obj){
    try {
      this._categorias.edit(obj, obj.uid);
    } catch (error) {
      console.log({error})
    }
  }

  eliminar(obj){
    Swal.fire({
      title: 'Eliminar Categoría',
      html: "¿Quieres eliminar la categoría <strong>"+ obj.categoria + "</strong>?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#009045',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {

        try {
          // Eliminar 
          removeItemFromArr(this.ds_categorias, obj);

          this._categorias.delete(obj.uid);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Categoría Eliminada',
            showConfirmButton: false,
            timer: 1500
          })
          
        } catch (error) {
          console.log({error})
        }

      }
    })
  }

  ordena(index, pos:number){

    let original = null;
    let afectado = null;

    if(pos > 0){

      original = this.ds_categorias[index];
      afectado = this.ds_categorias[index - 1];
      
      this.ds_categorias.splice(index -1 ,1,original);
      this.ds_categorias.splice(index,1,afectado);
      
      this.ds_categorias[index-1].orden = index -1;
      this.editarPosicion(this.ds_categorias[index-1]);
      this.ds_categorias[index].orden = index;
      this.editarPosicion(this.ds_categorias[index]);
      
    }else{

      original = this.ds_categorias[index];
      afectado = this.ds_categorias[index + 1];

      this.ds_categorias.splice(index +1 ,1,original);
      this.ds_categorias.splice(index,1,afectado);
      
      this.ds_categorias[index+1].orden = index +1;
      this.editarPosicion(this.ds_categorias[index  + 1]);
      this.ds_categorias[index].orden = index;
      this.editarPosicion(this.ds_categorias[index]);
      
    }

  }

}

function removeItemFromArr ( arr, item ) {
  var i = arr.indexOf( item );

  if ( i !== -1 ) {
      arr.splice( i, 1 );
  }
}
